import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CommonResponse } from "@core/classes/common-response";
import { environment } from "@environment/environment";
import { SessionStorageService } from "ngx-webstorage";
import { BehaviorSubject, Observable, lastValueFrom } from "rxjs";

const gateway = environment.config.apiUrl;
let tenants: any[] = [];
let eulas: any[] = [];

@Injectable({
  providedIn: 'root',
})
export class TenantService {

  private isLoaded$$: BehaviorSubject<boolean>;
  private isLoaded: boolean = false;

  actualTenant: any = {};
  actualEula: any[] = [];

  env: string = 'local';


  constructor(
    private http: HttpClient,
    private router: Router,
    private sessionStorage: SessionStorageService,
  ) {
    this.isLoaded$$ = new BehaviorSubject(this.isLoaded);

    console.log(`env file:${environment.env_file}`);
  }


  isLoaded$(): Observable<boolean> {
    return this.isLoaded$$.asObservable();
  }

  init(): void {

    this.env = this.getActiveEnv();

    if (!tenants.length) {
      this.fetchTenants();
    }
  }


  private async fetchTenants(): Promise<void> {

    const url = `${gateway}/auth/tenants`;

    await lastValueFrom(this.http.get<CommonResponse>(url))
      .then(async (resp: any) => {
        tenants = [];
        tenants = [...resp.map((r: any) => ({ id: r.id, config: r.config }))];
        await this.checkActualTenant();
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(async () => {

        //verifica se conseguiu carregar os tenants
        if (!tenants.length) {
          this.router.navigate(['503'], { replaceUrl: false, skipLocationChange: true, preserveFragment: false });
          this.isLoaded$$.next(false);

          console.log("===========", "Tenant service not loaded.");
          return;
        }

        this.actualTenant = tenants.find(r => r.id === this.getActiveTenant());
        await this.fetchEulas();

        this.isLoaded = true;
        this.isLoaded$$.next(this.isLoaded);
        console.log("===========", "Tenant service loaded.");
      });

  }

  private async checkActualTenant() {
    if (!tenants.find(r => r.id === this.getActiveTenant())) {
      this.router.navigate(['404']);
    }
  }

  private async fetchEulas(): Promise<void> {

    const url = `${gateway}/auth/tenants/${this.actualTenant.id}/eula`;

    await lastValueFrom(this.http.get<CommonResponse>(url))
      .then(async (resp: any) => {
        eulas = [];
        eulas = [...resp];
        this.actualEula = eulas;
      });

  }


  getActiveTenant(): string {

    let hostname = location.hostname;
    let host = hostname.split(".")[0];

    return host.toUpperCase();
  }

  getActiveEnv(): string {

    let hostname = location.hostname;
    let parts = hostname.split(".");
    let envi = 'prod';

    //xyz.dev.itek.dental
    //xyz.test.itek.dental
    //xyz.itek.dental
    //xyz.localhost.dental
    //xyz.localhost
    if (parts.length == 4) {
      envi = parts[1];
    } else if (parts.length <= 3) {
      if (parts[1].toLowerCase() !== "itek" || parts[2].toLowerCase() !== "dental") {
        envi = 'local';
      }
    }

    return envi.toLowerCase();
  }

  async createTenant(tenant: any): Promise<boolean> {
    return new Promise((res) => {
      setTimeout(() => {
        res(true);
      }, 3000);
    });
  }

  async getTenantsList(obj: any): Promise<any> {

    const { page, param } = obj;

    let pagina: any = {};
    if ((page != null) && (+page >= 0)) {
      pagina = { "x-page": page.toString() };
    }

    let filtro: any = {};
    if (param && param.filter !== "") {
      filtro = { 'x-param-filter': param.filter };
    }

    const tenant = { 'x-tenant-id': this.actualTenant.id };

    const user = { 'x-user-id': this.sessionStorage.retrieve('userId') };

    let lista: any[] = [];
    const url = `${gateway}/t/list`;
    lista = await lastValueFrom(this.http.get(url, { headers: { ...pagina, ...filtro, ...tenant, ...user } }))
      .then(async (resp: any) => {
        return resp;
      })
      .catch((err) => {
        console.log(err);
      });

    return lista;
    
  }

}